<template>
  <div class="ArtistProfile_Listings my-12">
    <div v-if="isPending" class="text-primary flex justify-center mb-10">
      <i class="fal fa-spinner-third fa-spin" />
    </div>
    <div v-else-if="data?.listings?.length === 0">No {{ searchType }} Available</div>
    <div>
      <div class="ArtistProfile_Listings_grid">
        <ListingItem v-for="listing in data?.listings || []" :listing="listing" :key="listing.id">
          <a :href="listing.url">
            <img
              class="ArtistProfile_Listings-img img-responsive img-max lazyload"
              :id="'ListingImg__' + listing.id"
              :data-src="
                $mq
                  | mq({
                    xs: listing.images.profile.mobile,
                    sm: listing.images.profile.tablet,
                    md: listing.images.profile.desktop,
                  })
              "
              :src="listing.images.profile.tiny"
              :alt="listing.title"
              :title="listing.title"
            />
          </a>
        </ListingItem>
      </div>
    </div>

    <PaginationWithDefaults v-model="page" :page-count="data?.total_pages || 0" v-show="data?.total_pages > 1" />
  </div>
</template>

<script setup>
import PaginationWithDefaults from "@/components/PaginationWIthDefaults.vue"
import Http from "@/lib/Http"
import { useQuery } from "@tanstack/vue-query"
import ListingItem from "@/components/Listing/Item.vue"

import { inject, computed, watch } from "vue"

const per = inject("per")
const sort = inject("sort")
const artist = inject("artist")
const currentPage = inject("page")
const setPage = inject("setPage")
const scope = inject("scope")
const scrollToTabs = inject("scrollToTabs")
const activeTab = inject("activeTab")

const page = computed({
  set(page) {
    scrollToTabs()
    setPage(page)
  },
  get() {
    return currentPage.value
  },
})

const searchType = computed(() => {
  switch (sort.value) {
    case "prints":
      return "Prints"
    case "originals":
      return "Originals"
    default:
      return "Artworks"
  }
})

async function fetchListings() {
  const data = await Http.get(`/api/artists/${artist.id}/listings`, {
    params: { sort: sort.value, scope: scope.value, page: currentPage.value, per: per.value },
  })
  return data.data
}

const queryKey = computed(() => `listings_${artist.id}_${scope.value}_${sort.value}_${currentPage.value}_${per.value}`)

const { isPending, data } = useQuery({
  queryKey: [queryKey],
  queryFn: fetchListings,
  refetchOnWindowFocus: false,
})

watch(activeTab, (newValue) => {
  if (["available", "sold", "reprints"].includes(newValue)) {
    scope.value = newValue
  }
})
</script>

<script>
export default {
  name: "Listings",
}
</script>

<style lang="scss" scoped>
.ArtistProfile_Listings_grid {
  display: grid;
  column-gap: 20px;
  row-gap: 30px;
  grid-column-gap: 20px;
  grid-row-gap: 30px;
  @media (min-width: theme("screens.sm")) {
    grid-template: auto / repeat(2, 1fr);
  }
  @media (min-width: theme("screens.md")) {
    grid-template: auto / repeat(3, 1fr);
  }
  @media (min-width: theme("screens.lg")) {
    grid-template: auto / repeat(4, 1fr);
  }
}
</style>
